export default __webpack_public_path__ + "static/media/thermometer.dcecfc3c.svg";